import { Not, Rule, StringListContains } from '@vendasta/automata';
import { ParameterPath, commonExcludedSKUs } from './billing-purchase-success.constants';

export function path(): string {
  return '{.sku}';
}

export function rule(skus: string[]): Rule {
  return new Not(new StringListContains(ParameterPath.SKU, commonExcludedSKUs.concat(skus)));
}
